var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"consultation"},[_c('com-list',{attrs:{"data":_vm.coStyle,"title":"合作形式"}}),_c('co-area'),_c('com-service'),_c('com-tea'),_c('com-partner',{attrs:{"partners":_vm.partners}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }